/** Ownership groups (PRD v2.0 §3.2) — mirrors backend services/lead_assignment.py. */
export const GROUP_META = {
  P1: { name: "P1 · No contact", short: "No contact", meaning: "Dialer outcome — no conversation took place", tint: "bg-slate-100 text-slate-600" },
  P2: { name: "P2 · Engaged", short: "Engaged", meaning: "Spoke to someone — work in progress", tint: "bg-amber-100 text-amber-800" },
  P3: { name: "P3 · Captured", short: "Captured", meaning: "Success — the campaign goal", tint: "bg-emerald-100 text-emerald-800" },
  P4: { name: "P4 · Closed", short: "Closed", meaning: "Dead — no further calls", tint: "bg-rose-100 text-rose-800" },
};

export const GROUP_ORDER = ["P1", "P2", "P3", "P4"];

export const groupName = (key) => GROUP_META[key]?.name || key;
export const groupTint = (key) => GROUP_META[key]?.tint || "bg-indigo-100 text-indigo-800";

/** Ordered group keys present in a set of options (extra groups appended). */
export function groupsOf(options) {
  const seen = [...new Set((options || []).map((o) => o.ownership_group || o.group).filter(Boolean))];
  const known = GROUP_ORDER.filter((g) => seen.includes(g));
  return [...known, ...seen.filter((g) => !GROUP_ORDER.includes(g)).sort()];
}
